export default {
  deleteTitle: 'Milestone',
  overviewTitle: 'Milestone',
  overviewRouterUrl: 'milestones',
  getFilterName (context) { return 'milestones' },
  overviewApiUrl: '/milestones/',
  detailTitle: 'Milestone Detail',
  detailRouterUrl: 'milestone',
  detailApiUrl: '/milestones/',
  quickFilterName: 'Intake',
  quickFilterField: 'name',
  advancedSearch: true,
  updateNewRecord (context, rec) {
    rec.milestone_amount = 0.0
  },
  getDefaultFilter (context) { return {} },
  sortOrder: [
    {
      field: 'intake',
      sortField: 'intake',
      direction: 'asc'
    }
  ],
  fields:
  [
    {title: 'Intake', name: 'intake', sortField: 'intake', link: '#/studentfee/{id}'},
    {title: 'Scholarship', name: 'scholarship_code', sortField: 'scholarship_code'},
    {title: 'Year', name: 'year', sortField: 'year'},
    {title: 'Date', name: 'milestone_date', sortField: 'milestone_date', callback: 'formatDate'},
    {title: 'Amount', name: 'milestone_amount', sortField: 'milestone_amount'},
    {title: 'Last Edit', name: 'edit_timestamp', sortField: 'edit_timestamp', callback: 'formatTimeStamp'},
    {name: '__slot:actions', title: '', titleClass: 'text-center', dataClass: 'text-center'}
  ]
}



// WEBPACK FOOTER //
// ./src/views/Milestone/FieldDefs.js